import { defineMessages } from 'react-intl'

export default defineMessages({
  cardTypes: {
    id: 'components.BankCardTypePrompt.cardTypes',
    defaultMessage: 'Card Types',
    description: 'Card Types',
  },
})
